import { QuestionStep } from '../QuestionStep';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ChoiceGrid } from './_shared';
import { GOAL_OPTIONS, STEPS, type QuestionnaireAnswers } from '../questions';

interface GoalStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function GoalStep({ answers, onChange }: GoalStepProps) {
  const step = STEPS.find((s) => s.id === 'goal')!;
  return (
    <QuestionStep step={step}>
      <ChoiceGrid
        options={GOAL_OPTIONS}
        value={answers.goal}
        onChange={(v) => onChange({ goal: v })}
        columns={3}
      />
      {answers.goal === 'other' ? (
        <div className="mt-6 grid max-w-xl gap-2">
          <Label htmlFor="goal-other">Tell us briefly</Label>
          <Input
            id="goal-other"
            value={answers.goal_other ?? ''}
            onChange={(e) => onChange({ goal_other: e.target.value })}
            placeholder="A short description of what you are building"
            maxLength={200}
          />
        </div>
      ) : null}
    </QuestionStep>
  );
}
